/** Ant Design v6: Form `name` is rendered as the native form element's `id`. */
export function antdFormRootSelector(formName: string): string {
  return `form#${CSS.escape(formName)}`;
}
